export interface Merchant {
  MerchantId: number;
  Name: string;
  BasePrice?: number;
  PerSmsprice?: number;
  PerLocationPrice?: number;
  PerDevicePrice?: number;
  PerCampaignPrice?: number;
  SalesRepresentativeId?: number | null;
  SalesRepresentativeName?: string | null;
  HasPhoneNumberAttached?: boolean;
  HasAccess?: boolean;
}
